export default "__VITE_ASSET__edc948bc__"